import { forwardRef } from 'react';
import { useController } from 'react-hook-form';
import InputAdornment from '@mui/material/InputAdornment';
import MuiTextField from '@mui/material/TextField';
import Tooltip from '../Tooltip';

export const TextField = forwardRef(({ tooltip, slotProps, select, ...rest }, ref) => {
  const mergedSlotProps = {
    ...slotProps,
    input: {
      ...slotProps?.input,
      ...(tooltip && {
        endAdornment: (
          <InputAdornment position="end" sx={select ? { mr: 2 } : undefined}>
            <Tooltip title={tooltip} />
          </InputAdornment>
        ),
      }),
    },
  };

  return <MuiTextField ref={ref} fullWidth select={select} slotProps={mergedSlotProps} {...rest} />;
});

/** TextField integrated with React Hook Form */
export const RhfTextField = ({ control, name, ...rest }) => {
  const { field, fieldState } = useController({
    name,
    control,
  });

  return <TextField {...field} {...rest} error={!!fieldState.error} helperText={fieldState.error?.message} />;
};
